import { useState, useEffect } from "react";
import { getManagementSummary } from "../actions";
import { resolveErrorMessage } from "../util";

const useGetManagementSummary = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const response = await getManagementSummary();
        setSummary(response);
      } catch (error) {
        const errorMessage = resolveErrorMessage(error)
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  return { summary, loading, error };
};

export default useGetManagementSummary;
